import { EvaluatorContext } from "../../evaluator/Evaluator"
import Evaluation from "../../Evaluation"
import ConfigEntity from "../../../workspace/config/entity/ConfigEntity"
import LocalEvaluateRequest from "./LocalEvaluateRequest"

export default abstract class ReferenceLocalEvaluator<REFERENCE extends ConfigEntity, EVALUATION extends Evaluation> {
  evaluate(parentRequest: LocalEvaluateRequest, context: EvaluatorContext, reference: REFERENCE): EVALUATION {
    const cached = context.getEvaluation(reference)
    if (cached) {
      return cached as EVALUATION
    }
    const evaluation = this.doEvaluate(parentRequest, context, reference)
    context.addEvaluation(evaluation)
    return evaluation
  }

  protected abstract doEvaluate(
    parentRequest: LocalEvaluateRequest,
    context: EvaluatorContext,
    reference: REFERENCE
  ): EVALUATION
}
